import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandedButton, { type BrandedButtonProps } from '@wix/da-ds/pkg/Buttons/BrandedButton';

interface Props extends Omit<BrandedButtonProps, 'variant' | 'size'> {}

const BuyArtsAndCraftsButton: React.FC<Props> = props => {
  const { t } = useTranslation();
  return (
    <BrandedButton variant="originals" size="medium" {...props}>
      {t('actionbar.anc.buy')}
    </BrandedButton>
  );
};
BuyArtsAndCraftsButton.displayName = 'BuyArtsAndCraftsButton';

export default BuyArtsAndCraftsButton;
